<template>
  <div name="snackbars">
    <v-snackbar v-model="show" :color="color" :timeout="timeout" :top="'top'">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="show = false">
          بستن
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
    export default {
        name: 'snack',
        created() {
            this.$store.subscribe((mutation, state) => {

                if (!mutation.type.includes("snack/"))
                    return;

                this.text = state.snack.text;

                if (mutation.type === "snack/SHOW_ERROR")
                    this.color = '#ff7675';
                else if (mutation.type === "snack/SHOW_SUCCESS")
                    this.color = '#1adc68';
                else if (mutation.type === "snack/SHOW_INFO")
                    this.color = '#fb8c00';

                this.show = true;
            });
        },
        data() {
            return {
                show: false,
                color: "",
                text: "",
                timeout: 4000,
            };
        },
    };
</script>